import * as React from "react";
import { Link } from "react-router-dom";

import styled from "../../styled-components";
import { media } from "../../breakpoints";
import * as ReactMarkdown from "react-markdown";

const Wrapper = styled.div`
  background: ${props => props.theme.colors.white};
  min-height: 100vh;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 800px;
  min-height: calc(100vh - 16px);
  padding: 0 20px;
`;

const HeaderContainer = Container.extend`
  height: auto;
  min-height: auto;
  padding: 0 0 20px 0;
  max-width: 800px;
  margin: 0 auto;
`;

const Main = styled.main`
  margin-top: 15px;
`;

const Header = styled.header`
  padding: 120px 20px 0;
  background-color: ${props => props.theme.colors.lightGray};
`;

const Title = styled.h1`
  font-family: ${props => props.theme.fonts.sans};
  font-size: 30px;
  font-weight: 400;
  margin-bottom: 30px;
  line-height: 40px;
  text-align: center;
  ${media.TABLET`
    font-size: 22px;
  `};
`;

const SubTitle = styled.h2`
  font-family: ${props => props.theme.fonts.sans};
  color: ${props => props.theme.colors.black};
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 35px;
  text-align: center;

  ${media.TABLET`
    font-size: 12px;
  `};
`;

const BodyText = styled.p`
  font-size: 20px;
  margin-top: 15px;
  color: ${props => props.theme.colors.black};
`;

const RouterLink = styled(Link)`
  border-bottom: 1px solid transparent;
  color: ${props => props.theme.colors.orange};
  text-decoration: none;
`;

const NativeLink = styled.a`
  border-bottom: 1px solid transparent;
  color: ${props => props.theme.colors.orange};
  text-decoration: none;
  transition: border-bottom 0.25s ease;

  &:hover {
    border-bottom: 1px solid ${props => props.theme.colors.orange};
  }
`;

interface IProps {
  pretitle?: any;
  title: string;
  byline?: string;
  children?: any;
  headerContent?: string;
  headerRawContent?: any;
}

const SimplePage: React.SFC<IProps> = (props: IProps) => (
  <Wrapper>
    <Header>
      <Title>{props.title}</Title>
      {props.byline ? <SubTitle>{props.byline}</SubTitle> : null}
      <HeaderContainer>
        {props.headerContent ? (
          <ReactMarkdown source={props.headerContent} />
        ) : (
          props.headerRawContent
        )}
      </HeaderContainer>
    </Header>
    <Container>
      <Main>
        {props.pretitle ? props.pretitle : null}
        <div>{props.children}</div>
      </Main>
    </Container>
  </Wrapper>
);

export { BodyText, IProps, NativeLink, RouterLink, SimplePage };
export default SimplePage;



// WEBPACK FOOTER //
// ./src/components/SimplePage/SimplePage.tsx